module.exports = __webpack_public_path__ + "img/c35.7da11497.png";